import { ref } from "vue";
import { useNuxtApp } from "#app";
import { useAuthStore } from "~/stores/auth";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";

export function useUserProfile() {
  const { $db } = useNuxtApp();
  const auth = useAuthStore();

  const profile = ref(blankProfile(auth.user));
  const loading = ref(false);
  const error = ref("");

  function blankProfile(u) {
    return {
      uid: u?.uid || "",
      email: u?.email || "",
      displayName: u?.displayName || "",
      phone: "",
      shipping: {
        fullName: u?.displayName || "",
        line1: "",
        city: "",
        postalCode: "",
      },
      instagram: "",
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    };
  }

  async function fetchProfile() {
    if (!auth.user) return;
    loading.value = true;
    error.value = "";
    try {
      const ref = doc($db, "users", auth.user.uid);
      const snap = await getDoc(ref);
      profile.value = snap.exists()
        ? { id: snap.id, ...snap.data() }
        : blankProfile(auth.user);
    } catch (e) {
      error.value = e?.message || String(e);
    } finally {
      loading.value = false;
    }
  }

  async function saveProfile() {
    if (!auth.user || !profile.value) return;
    const ref = doc($db, "users", auth.user.uid);
    const payload = {
      ...profile.value,
      uid: auth.user.uid,
      email: auth.user.email || profile.value.email || "",
      updatedAt: serverTimestamp(),
    };
    await setDoc(ref, payload, { merge: true });
  }

  return { profile, loading, error, fetchProfile, saveProfile };
}
